// import React, { useState, useRef } from 'react';
// import emailjs from '@emailjs/browser';
// import '../styles/Contact.css';

// const EMAILJS_SERVICE_ID  = 'service_emw1dtg';
// const EMAILJS_TEMPLATE_ID = 'template_z854taf';
// const EMAILJS_PUBLIC_KEY  = 'l8OnuBzpBw-zVBLAN';

// function Contact() {
//   const formRef = useRef();
//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', subject: '', message: ''
//   });
//   const [isRobot, setIsRobot] = useState(false);
//   const [status, setStatus] = useState('idle');
//   const [errorMsg, setErrorMsg] = useState('');

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isRobot) {
//       alert('Please check "I am not a robot"');
//       return;
//     }
//     setStatus('sending');
//     setErrorMsg('');
//     try {
//       await emailjs.send(
//         EMAILJS_SERVICE_ID,
//         EMAILJS_TEMPLATE_ID,
//         {
//           name:    formData.name,
//           email:   formData.email,
//           phone:   formData.phone,
//           subject: formData.subject,
//           message: formData.message,
//         },
//         EMAILJS_PUBLIC_KEY
//       );
//       setStatus('success');
//       setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//       setIsRobot(false);
//     } catch (error) {
//       console.error('EmailJS error:', error);
//       setStatus('error');
//       setErrorMsg(error?.text || 'Something went wrong. Please try again.');
//     }
//   };

//   return (
//     <div className="contact-page">

//       <div className="contact-header">
//         <p className="contact-sub">Have a query?</p>
//         <h1 className="contact-title">CONTACT US NOW!</h1>
//         <hr className="contact-divider" />
//         <p className="contact-desc">
//           Fill in the form below, specifying the subject of your question
//           and we'll get back to you.
//         </p>
//       </div>

//       <div className="contact-content">

//         <div className="contact-left">

//           {status === 'success' && (
//             <div className="form-banner success-banner">
//               ✅ Message sent! We will get back to you soon.
//             </div>
//           )}
//           {status === 'error' && (
//             <div className="form-banner error-banner">
//               ❌ {errorMsg}
//             </div>
//           )}

//           <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>

//             <div className="form-group">
//               <label>Your Name (required)</label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Your Email (required)</label>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Your Email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Your Phone (required)</label>
//               <input
//                 type="tel"
//                 name="phone"
//                 placeholder="Your Phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Subject</label>
//               <input
//                 type="text"
//                 name="subject"
//                 placeholder="Enter Subject"
//                 value={formData.subject}
//                 onChange={handleChange}
//               />
//             </div>

//             <div className="form-group">
//               <label>Your Message</label>
//               <textarea
//                 name="message"
//                 placeholder="Please Enter Your Message"
//                 rows="6"
//                 value={formData.message}
//                 onChange={handleChange}
//               ></textarea>
//             </div>

//             <div className="captcha-box">
//               <input
//                 type="checkbox"
//                 id="robot"
//                 checked={isRobot}
//                 onChange={() => setIsRobot(!isRobot)}
//               />
//               <label htmlFor="robot">I'm not a robot</label>
//               <span className="recaptcha-text">reCAPTCHA</span>
//             </div>

//             <button
//               type="submit"
//               className="send-btn"
//               disabled={status === 'sending'}
//             >
//               {status === 'sending' ? 'Sending...' : 'Send'}
//             </button>

//           </form>
//         </div>

//         <div className="contact-right">

//           <div className="contact-info-item">
//             <div className="info-icon">🏠</div>
//             <div>
//               <p><strong>Corporate Office :</strong> Sawarde Nayara Petrol Pump, Chiplun</p>
//               <p>Ratnagiri, Maharashtra - 415606</p>
//             </div>
//           </div>

//           <div className="contact-info-item">
//             <div className="info-icon">🏠</div>
//             <div>
//               <p><strong>Registered Office :</strong> Sawarde Nayara Petrol Pump, Chiplun</p>
//               <p>Ratnagiri, Maharashtra - 415606</p>
//             </div>
//           </div>

//           <div className="contact-info-item">
//             <div className="info-icon">✉️</div>
//             <div>
//               <p><strong>Email:</strong>{' '}
//                 <a href="mailto:info@sachinkathindustries.com">info@sachinkathindustries.com</a>
//               </p>
//             </div>
//           </div>

//           <div className="contact-info-item">
//             <div className="info-icon">📱</div>
//             <div>
//               <p><strong>Mobile:</strong> +91 9665621383</p>
//             </div>
//           </div>

//           <div className="contact-info-item">
//             <div className="info-icon">💬</div>
//             <div>
//               <p><strong>Skype:</strong>{' '}
//                 <a href="skype:wesderby.india?chat">Sachin Kath Industries.india</a>
//               </p>
//             </div>
//           </div>

//           <div className="map-container">
//             <iframe
//               title="Office Location"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.5!2d73.5279!3d17.4007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI0JzAyLjUiTiA3M8KwMzEnNDAuNCJF!5e0!3m2!1sen!2sin!4v1"
//               width="100%"
//               height="250"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             ></iframe>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default Contact;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const WEB3FORMS_KEY = '2b0bfa96-2657-4cf8-9c78-d61543688285';

const products = [
  { img: '/cl.png', related: ['/darkcutch.jpg', '/cutchblocks.jpg', '/FoodGradeCutch.jpg'] },
  { img: '/al.png', related: ['/FoodGradeAcaciaPowder.jpg', '/HighPurityAcaciaPowder.jpg', '/NaturalAcaciaPowder.jpg'] },
  { img: '/ql.png', related: ['/LeatherGradeQuebracho.jpg', '/UnsulphitedQuebracho.jpg', '/IndustrialGradeCatechu.jpg'] },
  { img: '/il.png', related: ['/LightKatha.jpg', '/FoodGradeKatha.jpg', '/DarkKatha.jpg'] },
  { img: '/ml.png', related: ['/ml.png', '/MachineKatha2.jpg', '/MachineKathaPowder.jpg'] },
];

function Footer() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: ''
  });
  const [isRobot, setIsRobot] = useState(false);
  const [lightbox, setLightbox] = useState({ open: false, images: [], activeIndex: 0 });
  const [isSending, setIsSending] = useState(false);
  const [statusMsg, setStatusMsg] = useState({ text: '', type: '' });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isRobot) {
      setStatusMsg({ text: 'Please check "I am not a robot".', type: 'error' });
      return;
    }
    setIsSending(true);
    setStatusMsg({ text: '', type: '' });
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          name:    formData.name,
          email:   formData.email,
          phone:   formData.phone,
          subject: `New Enquiry: ${formData.subject}`,
          message: formData.message,
        }),
      });
      const result = await response.json();
      console.log('Web3Forms result:', result);
      if (result.success) {
        setStatusMsg({ text: '✅ Message sent successfully! We will contact you soon.', type: 'success' });
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setIsRobot(false);
      } else {
        console.error('Web3Forms error:', result);
        setStatusMsg({ text: result.message || '❌ Failed to send. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setStatusMsg({ text: '❌ Network error. Please check internet and try again.', type: 'error' });
    } finally {
      setIsSending(false);
    }
  };

  const openLightbox = (related) => setLightbox({ open: true, images: related, activeIndex: 0 });
  const closeLightbox = () => setLightbox({ open: false, images: [], activeIndex: 0 });
  const prevImage = () => setLightbox((prev) => ({
    ...prev, activeIndex: (prev.activeIndex - 1 + prev.images.length) % prev.images.length
  }));
  const nextImage = () => setLightbox((prev) => ({
    ...prev, activeIndex: (prev.activeIndex + 1) % prev.images.length
  }));

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-col">
          <h3 className="footer-title">Sachin Kath Industries</h3>
          <div className="footer-info">
            <p><strong>Registered Office:</strong> Sawarde Nayara Petrol Pump, Chiplun</p>
            <p>Ratnagiri, Maharashtra - 415606</p><br />
            <p><strong>Corporate Office:</strong> Sawarde Nayara Petrol Pump, Chiplun</p>
            <p>Ratnagiri, Maharashtra - 415606</p><br />
            <p><strong>Email:</strong> <a href="mailto:info@sachinkathindustries.com">info@sachinkathindustries.com</a></p>
            <p><strong>Phone:</strong> +91 9665621383</p>
          </div>
        </div>

        <div className="footer-col">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/who-we-are">About Us</Link></li>
            <li><Link to="/rice">Our Products</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
          <h3 className="footer-title" style={{ marginTop: '24px' }}>Follow Us</h3>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/sachin-kath-industries/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.45 20.45h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.354V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/sachinkath_industries/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61591097447895" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 1.885-.287 1.782h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h3 className="footer-title">Latest Products</h3>
          <div className="footer-products">
            {products.map((p, i) => (
              <button key={i} className="footer-product-btn"
                onClick={() => openLightbox(p.related)}
                aria-label={`View product ${i + 1} gallery`}>
                <img src={p.img} alt={`Product ${i + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <h3 className="footer-title">Contact us</h3>
          <form className="footer-form" onSubmit={handleSubmit}>
            <div className="footer-form-row">
              <input type="text" name="name" placeholder="Your Name"
                value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Your Email"
                value={formData.email} onChange={handleChange} required />
            </div>
            <div className="footer-form-row">
              <input type="tel" name="phone" placeholder="Your Phone"
                value={formData.phone} onChange={handleChange} required />
              <input type="text" name="subject" placeholder="Your Subject"
                value={formData.subject} onChange={handleChange} />
            </div>
            <textarea name="message" placeholder="Message" rows="5"
              value={formData.message} onChange={handleChange}></textarea>
            <div className="footer-captcha">
              <input type="checkbox" id="footer-robot" checked={isRobot}
                onChange={() => setIsRobot(!isRobot)} />
              <label htmlFor="footer-robot">I'm not a robot</label>
              <span className="footer-recaptcha">reCAPTCHA</span>
            </div>
            {statusMsg.text && (
              <p className={`footer-status-msg ${statusMsg.type}`}>
                {statusMsg.text}
              </p>
            )}
            <button type="submit" className="footer-send-btn" disabled={isSending}>
              {isSending ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>

      </div>

      {lightbox.open && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-modal" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox} aria-label="Close">✕</button>
            <div className="lightbox-main">
              {lightbox.images.length > 1 && (
                <button className="lightbox-arrow lightbox-prev" onClick={prevImage}>&#8249;</button>
              )}
              <img src={lightbox.images[lightbox.activeIndex]}
                alt={`Product ${lightbox.activeIndex + 1}`} className="lightbox-img" />
              {lightbox.images.length > 1 && (
                <button className="lightbox-arrow lightbox-next" onClick={nextImage}>&#8250;</button>
              )}
            </div>
            {lightbox.images.length > 1 && (
              <div className="lightbox-thumbs">
                {lightbox.images.map((img, idx) => (
                  <button key={idx}
                    className={`lightbox-thumb-btn ${idx === lightbox.activeIndex ? 'active' : ''}`}
                    onClick={() => setLightbox((prev) => ({ ...prev, activeIndex: idx }))}>
                    <img src={img} alt={`Thumb ${idx + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;